import React from "react";
import { Divider, Typography, Grid, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicTable from "./Tabla";
import CodeContent from "./CodeContent";
import EndpointContent from "./EndpointContent";
import TabLenguaje from './TabLenguaje';

function createData(
    campo,
    Tipo,
    valorEjemplo,
    Descripcion
) {
    return { campo, Tipo, valorEjemplo, Descripcion };
}

const RecoverProduct = () => {
    const [t] = useTranslation('global');
    const code =
        `
    curl --location 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677'
    --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd...'
    --header 'Content-Type: application/json'
        `;
    const cCurl1 =
    `  
        curl --location --request GET 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677'
        --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
        --header 'Content-Type: application/json'
        --data '{ ... }'
        `;
    const csRS1 =
    `   
        var options = new RestClientOptions("")
        {
        MaxTimeout = -1,
        };
        var client = new RestClient(options);
        var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677", Method.Get);
        request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
        request.AddHeader("Content-Type", "application/json");
        var body = @"{ ... }";
        request.AddStringBody(body, DataFormat.Json);
        RestResponse response = await client.ExecuteAsync(request);
        Console.WriteLine(response.Content);
            `;
    const javaOK1 =
    `        
        OkHttpClient client = new OkHttpClient().newBuilder()
        .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{ ... }");
        Request request = new Request.Builder()
        .url("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677")
        .method("GET", body)
        .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
        .addHeader("Content-Type", "application/json")
        .build();
        Response response = client.newCall(request).execute();
            `
    ;
    const phpHC1 =
    `
        <?php
        require_once 'HTTP/Request2.php';
        $request = new HTTP_Request2();
        $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677');
        $request->setMethod(HTTP_Request2::METHOD_GET);
        $request->setConfig(array(
        'follow_redirects' => TRUE
        ));
        $request->setHeader(array(
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
        'Content-Type' => 'application/json'
        ));
        $request->setBody('{ ... }');
        try {
        $response = $request->send();
        if ($response->getStatus() == 200) {
            echo $response->getBody();
        }
        else {
            echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
            $response->getReasonPhrase();
        }
        }
        catch(HTTP_Request2_Exception $e) {
        echo 'Error: ' . $e->getMessage();
        }
    `;
    const csHTC1 =
    `         
        var client = new HttpClient();
        var request = new HttpRequestMessage(HttpMethod.Get, "https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677");
        request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
        var content = new StringContent("{ ... }", null, "application/json");
        request.Content = content;
        var response = await client.SendAsync(request);
        response.EnsureSuccessStatusCode();
        Console.WriteLine(await response.Content.ReadAsStringAsync());
        `;
    const javaUNI1 =
    `        
        Unirest.setTimeouts(0, 0);
        HttpResponse<String> response = Unirest.put("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677")
        .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
        .header("Content-Type", "application/json")
        .body("{}")
        .asString();
    
            `;
    const phpGZ1 =
    `     
        <?php
        $client = new Client();
        $headers = [
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
        'Content-Type' => 'application/json'
        ];
        $body = '{}';
        $request = new Request('GET', 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos?Codigo=Prod0904946&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677', $headers, $body);
        $res = $client->sendAsync($request)->wait();
        echo $res->getBody();
        `;
    /*Para varios productitos*/
    const codeMultiple =
        `
    curl --location 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677'
    --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd...'
    --header 'Content-Type: application/json'
        `;
        const cCurl2 =
        `  
            curl --location --request GET 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677'
            --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
            --header 'Content-Type: application/json'
            --data '{ ... }'
            `;
        const csRS2 =
        `   
            var options = new RestClientOptions("")
            {
            MaxTimeout = -1,
            };
            var client = new RestClient(options);
            var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677", Method.Get);
            request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
            request.AddHeader("Content-Type", "application/json");
            var body = @"{ ... }";
            request.AddStringBody(body, DataFormat.Json);
            RestResponse response = await client.ExecuteAsync(request);
            Console.WriteLine(response.Content);
                `;
        const javaOK2 =
        `        
            OkHttpClient client = new OkHttpClient().newBuilder()
            .build();
            MediaType mediaType = MediaType.parse("application/json");
            RequestBody body = RequestBody.create(mediaType, "{ ... }");
            Request request = new Request.Builder()
            .url("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677")
            .method("GET", body)
            .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
            .addHeader("Content-Type", "application/json")
            .build();
            Response response = client.newCall(request).execute();
                `
        ;
        const phpHC2 =
        `
            <?php
            require_once 'HTTP/Request2.php';
            $request = new HTTP_Request2();
            $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677');
            $request->setMethod(HTTP_Request2::METHOD_GET);
            $request->setConfig(array(
            'follow_redirects' => TRUE
            ));
            $request->setHeader(array(
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
            'Content-Type' => 'application/json'
            ));
            $request->setBody('{ ... }');
            try {
            $response = $request->send();
            if ($response->getStatus() == 200) {
                echo $response->getBody();
            }
            else {
                echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
                $response->getReasonPhrase();
            }
            }
            catch(HTTP_Request2_Exception $e) {
            echo 'Error: ' . $e->getMessage();
            }
        `;
        const csHTC2 =
        `         
            var client = new HttpClient();
            var request = new HttpRequestMessage(HttpMethod.Get, "https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677");
            request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
            var content = new StringContent("{ ... }", null, "application/json");
            request.Content = content;
            var response = await client.SendAsync(request);
            response.EnsureSuccessStatusCode();
            Console.WriteLine(await response.Content.ReadAsStringAsync());
            `;
        const javaUNI2 =
        `        
            Unirest.setTimeouts(0, 0);
            HttpResponse<String> response = Unirest.put("https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677")
            .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
            .header("Content-Type", "application/json")
            .body("{}")
            .asString();
        
                `;
        const phpGZ2 =
        `     
            <?php
            $client = new Client();
            $headers = [
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
            'Content-Type' => 'application/json'
            ];
            $body = '{}';
            $request = new Request('GET', 'https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples?Codigo=%2CProd0904897%2CProd0904896%2C&CodigoBarras=&PrecioConfiguracionCodigo=1&MonedaCodigo=PEN&Sucursal=3677', $headers, $body);
            $res = $client->sendAsync($request)->wait();
            echo $res->getBody();
            `;
    
    const codeResponse =
        `
        {
            "TipoProducto": "1",
            "ProductoCodigo": "Prod0904946",
            "ProductoCodigoSUNAT": "56112005",
            "ProductoDescripcion": "14 ENERO GRAV",
            "ProductoCodigoCliente": "ENERO14",
            "Observacion": "",
            "TipoAfectacionIGVCodigo": "10",
            "TipoSistemaISCCodigo": "00",
            "CodigoCategoria": 0,
            "Stock": 10.000000,
            "Cantidad": 1,
            "PrecioCodigo": "114985",
            "CantidadUnidadMedida": 1.000000,
            "UnidadMedidaCodigo": "NIU",
            "PrecioUnitario": 0.000000,
            "PrecioUnitarioSugerido": 0.00,
            "ICBPER": 0.000000000,
            "DescuentoIndicador": 0,
            "Descuento": 0,
            "DescuentoPorcentaje": 0,
            "DescuentoCargoCodigo": 0,
            "PercepcionCantidadUmbral": 0,
            "PercepcionMontoUmbral": 0.00,
            "PercepcionPorcentaje": 0.00,
            "Control": "0",
            "ValorUnitario": 0.00,
            "AplicaISC": false,
            "AplicaOtrosCargos": false,
            "AplicaICBPER": false,
            "Peso": 1.0,
            "Kit": false,
            "PrecioCompra": 200.000000,
            "ListaPrecios": [
                {
                    "PrecioId": 114985,
                    "PrecioConfiguracion": 1,
                    "ProductoCodigo": "Prod0904946",
                    "CodigoUnidadMedida": "NIU",
                    "DescripcionUnidadMedida": "UNIDAD",
                    "CantidadUnidadMedida": 1.000000,
                    "MonedaCodigo": "PEN",
                    "SucursalId": 3677,
                    "MargenGanancia": 0.000000,
                    "MargenPorcentaje": 0.000000,
                    "PrecioVenta": 0.000000,
                    "Sugerido": 0.000000,
                    "OtrosCargosPorcentaje": 0.000000,
                    "CantidadAplicable": 1.000000,
                    "FechaIngreso": "14/01/2023",
                    "FechaActualizacion": "14/01/2023",
                    "Estado": "1",
                    "ISCPorcentaje": 0.000000,
                    "ISCCalculado": 0.000000
                },
                .
                .
                .
            ]
        }
        `;

        const codeResponseMultiple =
        `
        [
            {
                "TipoProducto": "1",
                "ProductoCodigo": "Prod0904897",
                "ProductoCodigoSUNAT": "56112005",
                "ProductoDescripcion": "00 PRODUCTO EXONERADO 2.0",
                "ProductoCodigoCliente": "Prod0904897",
                "Observacion": "",
                "TipoAfectacionIGVCodigo": "20",
                "TipoSistemaISCCodigo": "00",
                "CodigoCategoria": 0,
                "Stock": 571.000000,
                "Cantidad": 1,
                "PrecioCodigo": "111551",
                "CantidadUnidadMedida": 1.000000,
                "UnidadMedidaCodigo": "NIU",
                "PrecioUnitario": 11.800000,
                "PrecioUnitarioSugerido": 0.00,
                "ICBPER": 0.000000000,
                "DescuentoIndicador": 0,
                "Descuento": 0,
                "DescuentoPorcentaje": 0,
                "DescuentoCargoCodigo": 0,
                "PercepcionCantidadUmbral": 0,
                "PercepcionMontoUmbral": 0.00,
                "PercepcionPorcentaje": 0.00,
                "Control": "0",
                "ValorUnitario": 0.00,
                "AplicaISC": false,
                "AplicaOtrosCargos": false,
                "AplicaICBPER": false,
                "Peso": 1.0,
                "Kit": false,
                "PrecioCompra": 0.983333,
                "ListaPrecios": [
                    {
                        "PrecioId": 111551,
                        "PrecioConfiguracion": 1,
                        "ProductoCodigo": "Prod0904897",
                        "CodigoUnidadMedida": "NIU",
                        "DescripcionUnidadMedida": "UNIDAD",
                        "CantidadUnidadMedida": 1.000000,
                        "MonedaCodigo": "PEN",
                        "SucursalId": 3677,
                        "MargenGanancia": 0.000000,
                        "MargenPorcentaje": 0.000000,
                        "PrecioVenta": 11.800000,
                        "Sugerido": 0.000000,
                        "OtrosCargosPorcentaje": 0.000000,
                        "CantidadAplicable": 0.000000,
                        "FechaIngreso": "30/12/2022",
                        "FechaActualizacion": "06/01/2023",
                        "Estado": "1",
                        "ISCPorcentaje": 0.000000,
                        "ISCCalculado": 0.000000
                    },
                    .
                    .
                    .
                ]
            },
            {
                "TipoProducto": "1",
                "ProductoCodigo": "Prod0904896",
                "ProductoCodigoSUNAT": "56112005",
                "ProductoDescripcion": "00 PRODUCTO GRAVADO",
                "ProductoCodigoCliente": "Prod0904896",
                "Observacion": "",
                "TipoAfectacionIGVCodigo": "10",
                "TipoSistemaISCCodigo": "00",
                "CodigoCategoria": 0,
                "Stock": 331.000000,
                "Cantidad": 1,
                "PrecioCodigo": "111539",
                "CantidadUnidadMedida": 1.000000,
                "UnidadMedidaCodigo": "NIU",
                "PrecioUnitario": 11.800000,
                "PrecioUnitarioSugerido": 0.00,
                "ICBPER": 0.000000000,
                "DescuentoIndicador": 0,
                "Descuento": 0,
                "DescuentoPorcentaje": 0,
                "DescuentoCargoCodigo": 0,
                "PercepcionCantidadUmbral": 0,
                "PercepcionMontoUmbral": 0.00,
                "PercepcionPorcentaje": 0.00,
                "Control": "0",
                "ValorUnitario": 0.00,
                "AplicaISC": false,
                "AplicaOtrosCargos": false,
                "AplicaICBPER": false,
                "Peso": 1.0,
                "Kit": true,
                "PrecioCompra": 5.000000,
                "ListaPrecios": [
                    {
                        "PrecioId": 111539,
                        "PrecioConfiguracion": 1,
                        "ProductoCodigo": "Prod0904896",
                        "CodigoUnidadMedida": "NIU",
                        "DescripcionUnidadMedida": "UNIDAD",
                        "CantidadUnidadMedida": 1.000000,
                        "MonedaCodigo": "PEN",
                        "SucursalId": 3677,
                        "MargenGanancia": 0.000000,
                        "MargenPorcentaje": 18.000000,
                        "PrecioVenta": 11.800000,
                        "Sugerido": 0.000000,
                        "OtrosCargosPorcentaje": 0.000000,
                        "CantidadAplicable": 0.000000,
                        "FechaIngreso": "30/12/2022",
                        "FechaActualizacion": "06/01/2023",
                        "Estado": "1",
                        "ISCPorcentaje": 0.000000,
                        "ISCCalculado": 0.000000
                    },
                    .
                    .
                    .
                ]
            }
        ]
        `;
    const rows = [
        createData('Codigo', "String", "Prod0904896", t('content.recuperarProducto.descripcionCodigo')),
        createData('CodigoBarras', "String", "Prod00001", t('content.recuperarProducto.descripcionCodigoBarras')),
        createData('PrecioConfiguracionCodigo', "Int", "1", t('content.recuperarProducto.descripcionPrecioConfiguracion')),
        createData('MonedaCodigo', "String", "PEN", t('content.recuperarProducto.descripcionMonedaCodigo')),
        createData('Sucursal', "Int", "3677", t('content.recuperarProducto.descripcionSucursal'))
    ];
    return (
        <div id="recoverproduct">
            <Divider sx={{ height: '70px' }} />
            <Typography variant="h3" id="recuperarProducto" gutterBottom>
                {t('content.recuperarProducto.titulo')}
            </Typography>
            <Typography variant="h5" gutterBottom>
                {t('content.recuperarProducto.subtitulo')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.recuperarProducto.descripcion')}
            </Typography>
            <br />
            <Typography variant="body1" id='recuperarProductoItem' gutterBottom>
                {t('content.recuperarProducto.descripcion2')}
            </Typography>
            <br/>
            <ul>
                <li>
                    <Typography variant="h6" gutterBottom>
                        {t('content.recuperarProducto.itemRecuperarProducto')}
                    </Typography>
                </li>
                <EndpointContent method={'GET'} path='https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productos'/>
                {/*<CodeContent code={code} id='recuperarProductoMultipleItem'/>*/}
                <TabLenguaje curl={cCurl1} csRS={csRS1} javaOK={javaOK1} phpRQ={phpHC1} csHC={csHTC1} java2UN={javaUNI1} php2GZ={phpGZ1} ></TabLenguaje>
                <li>
                    <Typography variant="h6" gutterBottom>
                        {t('content.recuperarProducto.itemRecuperarProductos')}
                    </Typography>
                </li>
                <EndpointContent method={'GET'} path='https://wsventas-exp.rapifac.com/v0/comprobanteDetalles/productosmultiples'/>
                {/*<CodeContent code={codeMultiple} />*/}
                <TabLenguaje curl={cCurl2} csRS={csRS2} javaOK={javaOK2} phpRQ={phpHC2} csHC={csHTC2} java2UN={javaUNI2} php2GZ={phpGZ2} ></TabLenguaje>
            </ul>
            <br id={"recuperarProductoRespuesta"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.recuperarProducto.subtituloRespuesta')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.recuperarProducto.descripcion3')}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} minWidth={300}>
                    <Box display='flex' justifyContent={'center'} flexDirection='column' alignItems='center'>
                        <Typography variant="h6" gutterBottom id="">
                            {t('content.recuperarProducto.jsonProducto')}
                        </Typography>
                        <CodeContent code={codeResponse} languajeCode='json' />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} minWidth={300}>
                    <Box display='flex' justifyContent={'center'} flexDirection='column' alignItems='center'>
                        <Typography variant="h6" gutterBottom id="">
                            {t('content.recuperarProducto.jsonProductoMultiple')}
                        </Typography>
                        <CodeContent code={codeResponseMultiple} languajeCode='json' />
                    </Box>
                </Grid>
            </Grid>
            
            <br id={"recuperarProductoDescripcionParametros"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.recuperarProducto.subtituloDescripcion')}
            </Typography>
            <BasicTable rows={rows} />
        </div>
    )
}
export default RecoverProduct;